export enum ScreenContentStatus {
    Waiting = 0,
    Pending = 1,
    Playing = 2,
    Uploading = 3
}
